import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Divider, TextField } from '@mui/material'
import * as XLSX from 'xlsx'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { getAllItemStyles } from '../../store/actions/itemStyleAction'
import { updateItemByExcel } from '../../store/actions/itemAction'

const ItemList = ({ item }) => (
    <TableRow>
        <TableCell>{item.id}</TableCell>
        <TableCell>{item.itemSKU}</TableCell>
        <TableCell>
            <span style={{ color: 'red' }}>{item?.itemstyleId}</span>
        </TableCell>
    </TableRow>
)

const ItemFailedList = ({ displayData }) => (
    <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Item SKU</TableCell>
                    <TableCell>Item Style ID</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {displayData?.map((item, index) => (
                    <ItemList item={item} key={index} />
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)

const ItemUploadForm = () => {
    const dispatch = useDispatch()
    const [excelData, setExcelData] = useState(null)
    const [displayData, setDisplayData] = useState(null)
    const [success, setSuccess] = useState(false)

    const { itemStyles } = useSelector((state) => state.itemCategory)

    useEffect(() => {
        dispatch(getAllItemStyles())
    }, [dispatch])

    const handleFileChange = useCallback((e) => {
        const file = e.target.files?.[0]
        if (!file) return

        const validTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'text/csv',
        ]
        if (
            !validTypes.includes(file.type) &&
            !/\.(xlsx|xls|csv)$/i.test(file.name)
        ) {
            alert('Please select a valid Excel (.xlsx/.xls)')
            return
        }

        setExcelData(file)
    }, [])

    const handleFileUpload = useCallback(
        async (e) => {
            if (!excelData) return

            const itemStyleIds =
                itemStyles?.map((itemStyle) => itemStyle.id) || []

            const data = await excelData.arrayBuffer()
            const workbook = XLSX.read(data, { type: 'array' })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]

            // Read as JSON (keys = column headers)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' })

            // Convert headers back to backend keys
            const convertedData = jsonData.map((row) => ({
                id: row['ID'],
                itemSKU: row['Item SKU'],
                itemName: row['Item Name'],
                packageLong: row['Width'],
                packageWidth: row['Height'],
                packageHeight: row['Depth'],
                volume: row['Volume'],
                weight: row['Weight'],
                weightUnit: row['Weight Unit'],
                MSRPinCAD: row['MSRP'],
                description: row['Description'],
                picLink: row['Picture Link'],
                alertStock: row['Alert Stock'],
                autoOrderQty: row['Auto Order Qty'],
                pcsPerBox: row['Pcs Per Box'],
                online: row['Online'],
                itemstyleId: row['Item Style ID'],
            }))

            const invalidItems = convertedData.filter(
                (item) =>
                    item.itemstyleId && !itemStyleIds.includes(item.itemstyleId)
            )

            if (invalidItems.length > 0) {
                setDisplayData(invalidItems)
                return
            }

            dispatch(
                updateItemByExcel(convertedData, setDisplayData, setSuccess)
            )
        },
        [dispatch, itemStyles, excelData]
    )

    return success ? (
        'All Items Updated Successfully'
    ) : (
        <>
            <div style={{ marginTop: '30px' }}>
                <TextField
                    size="small"
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handleFileChange}
                />
                <Button variant="outlined" onClick={handleFileUpload}>
                    Process File
                </Button>
            </div>
            {displayData && (
                <div style={{ marginTop: '30px' }}>
                    <Divider>
                        <span style={{ color: 'red' }}>Items not found</span>
                    </Divider>
                    <div style={{ margin: '30px' }} />
                    <ItemFailedList displayData={displayData} />
                </div>
            )}
        </>
    )
}

export default ItemUploadForm
